import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { ConfigProvider, Empty } from 'ant-design-vue';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { invoiceList } from '../request';
import { mapState } from 'vuex';
export default {
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  components: {
    ConfigProvider
  },
  data() {
    return {
      form: {
        customerId: undefined,
        applicationId: undefined,
        insuranceId: undefined,
        invoiceStatus: undefined
      },
      applicationList: [],
      productList: [],
      statusList: [{
        key: 'UNINVOICED',
        name: '未开票'
      }, {
        key: 'INVOICED_FAILED',
        name: '开票失败'
      }, {
        key: 'INVOICED_OFFSET',
        name: '已作废'
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      noDataText: '111',
      data: [],
      columns: [],
      selectedRowKeys: [],
      selectedRows: [],
      maxSelect: 10,
      loading: false
    };
  },
  computed: {
    ...mapState({
      accountInfo: state => state.user.accountInfo
    }),
    rowSelection() {
      const {
        selectedRowKeys
      } = this;
      return {
        selectedRowKeys,
        // 一定要加上这一行代码，清除才会有作用
        onChange: (selectedRowKeys, selectedRows) => {
          console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows, selectedRows.length, selectedRowKeys.length, this.selectedRowKeys.length, this.selectedRows.length, this.maxSelect);
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
          if (selectedRows.length > this.maxSelect) {
            this.$message.error(this.$t('保单至多勾选') + this.maxSelect + this.$t('个'));
            // 不选中当前
            this.selectedRowKeys = this.selectedRowKeys.filter(item => item != record.id);
            this.selectedRows = this.selectedRows.filter(item => item.id != record.id);
            return false;
          } else {
            this.selectedRowKeys = selectedRows.map(item => item.id);
            this.selectedRows = selectedRows;
          }
        },
        onSelectAll: (selected, selectedRows, changeRows) => {
          console.log(selected, selectedRows, changeRows, '全选', this.selectedRows.length);
          if (this.selectedRows.length == this.maxSelect || this.selectedRows.length == this.pagination.total) {
            // 取消全选
            this.selectedRowKeys = [];
            this.selectedRows = [];
          } else {
            // 全选
            if (this.selectedRows.length < this.maxSelect && this.selectedRows.length > 0) {
              selectedRows.forEach(item => {
                if (!this.selectedRowKeys.includes(item.id) && this.selectedRows.length < this.maxSelect) {
                  this.selectedRowKeys.push(item.id);
                  this.selectedRows.push(item);
                }
              });
            } else {
              this.selectedRows = selectedRows.slice(0, this.maxSelect);
              this.selectedRowKeys = this.selectedRows.map(item => item.id);
            }
          }
        }
      };
    }
  },
  created() {
    this.form.customerId = this.accountInfo.customerId;
    // 获取列表页-设置表头
    this.getListData();
    this.applicationFun();
  },
  mounted() {},
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    // 保单来源
    applicationFun() {
      applicationResource({
        customerId: this.form.customerId,
        position: 'policy'
      }).then(res => {
        this.applicationList = res;
      });
      this.getInsuranceFun();
    },
    // 产品名称
    getInsuranceFun() {
      this.productList = [];
      this.form.insuranceId = undefined;
      if (!this.form.applicationId) {
        return false;
      }
      insuranceResource({
        applicationId: this.form.applicationId,
        position: 'policy',
        customerId: this.form.customerId
      }).then(res => {
        this.productList = res;
      });
    },
    // 搜索
    searchFun() {
      this.data = [];
      this.pagination.current = 1;
      this.pagination.total = 0;
      this.selectedRows = [];
      this.selectedRowKeys = [];
      if (!this.form.applicationId || !this.form.insuranceId) {
        return false;
      }
      this.getListData();
    },
    // 重置
    rest() {
      this.form.applicationId = undefined;
      this.form.insuranceId = undefined;
      this.form.invoiceStatus = undefined;
      this.data = [];
      this.pagination = {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      };
      this.selectedRows = [];
      this.selectedRowKeys = [];
    },
    // 开具发票
    handleInvoice() {
      console.log(this.selectedRows, '开具发票');
      if (this.selectedRows.length == 0) {
        this.$message.error(this.$t('请勾选保单后，开具发票'));
        return false;
      }
      // 将选择的数据存储到store
      this.$store.dispatch('setting/setChooseInvoice', this.selectedRows);
      this.$router.push({
        path: `/invoiceManage/customerManage/invoiceList/invoiceWrite/${this.selectedRows.length}`,
        query: {
          customerId: this.form.customerId,
          applicationId: this.form.applicationId,
          insuranceId: this.form.insuranceId
        }
      });
    },
    async getListData() {
      this.loading = true;
      let params = {
        ...this.form,
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      };
      await invoiceList(params).then(res => {
        this.columns = res.fieldConfig;
        this.data = res.items;
        this.pagination.total = res !== null && res !== void 0 && res.totalNum ? res.totalNum : 0;
        this.loading = false;
      }).catch(err => {
        this.data = [];
        this.pagination.total = 0;
        this.loading = false;
      });
    },
    tablePageChange(val) {
      console.log(val, 'page');
      this.pagination = val;
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.getListData();
    }
  }
};